var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('router-link',{staticClass:"link-entity",attrs:{"to":_vm.to,"target":_vm.target}},[_c('v-icon',[_vm._v("mdi-link")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }